var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_24270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13754 11.9248C0.843336 11.9419 0.553996 11.8441 0.330533 11.652C-0.110178 11.2086 -0.110178 10.4926 0.330533 10.0493L9.98066 0.399122C10.439 -0.0297982 11.1583 -0.00595479 11.5872 0.452424C11.9751 0.866933 11.9977 1.50404 11.6402 1.94498L1.93317 11.652C1.71259 11.8413 1.42789 11.9389 1.13754 11.9248Z",
    fill: "#283856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7763 11.9248C10.4781 11.9235 10.1923 11.8052 9.98061 11.5952L0.330442 1.94497C-0.0778544 1.46817 -0.0223444 0.750623 0.45445 0.34229C0.880002 -0.022137 1.5076 -0.022137 1.93312 0.34229L11.6401 9.99245C12.0984 10.4215 12.1221 11.1408 11.693 11.5991C11.676 11.6173 11.6583 11.6349 11.6401 11.652C11.4024 11.8587 11.0896 11.9575 10.7763 11.9248Z",
    fill: "#283856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_24270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.368ab0e4e8b7ba17aa0c897574cdf77c.svg";
export { ForwardRef as ReactComponent };